import { Link, Menu, List, ListItem, } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box,  } from '@mui/system';

export const NotificationMenu = styled(Menu)(({  }) => ({
    '& .MuiList-root': {
        width: '320px !important',
        padding: 0,
        maxHeight: 300,
        overflow: 'auto',
        borderRadius: '12px',
    }
}));

export const NotificationLists = styled(List)(({ theme }) => ({
    display: 'block',
    margin: theme.spacing(2.5, 0, 0, 0),
    padding: 0,
}));

export const NotificationListItem = styled(ListItem)(({  }) => ({
    display: 'block',
    border: 'none',
    padding: 0,
    margin: 0,
    '&:not(:last-child)': {
        // marginBottom: theme.spacing(1.5),
        // borderBottom: '1px solid #cfd7e2',
    }
}));

export const NotificationLink = styled(Link)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    backgroundColor: '#fff',
    padding: theme.spacing(1.5, 2),
    borderBottom: '1px solid #d7dfeb',
    transition: '500ms',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:not(.read)': {
        backgroundColor: '#e4ecf5',
        // boxShadow: '0 4px 5px 0px rgb(191 197 215)',
        // borderColor: '#a3aebe',
    },
    '& h6': {
        display: 'block',
        color: theme.palette.primary.main,
        fontSize: 14,
        lineHeight: '18px',
        fontWeight: 600,
        overflow: 'hidden',
        textOverflow:'ellipsis',
        whiteSpace: 'nowrap',
    },
    
    '& p': {
        display: 'block',
        color: '#222',
        fontSize: 13.5,
        lineHeight: '17px',
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow:'ellipsis',
        whiteSpace: 'nowrap',
        marginTop: theme.spacing(0.55),
    },
    '& span': {
        display: 'block',
        marginTop: theme.spacing(0.75),
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
        color: '#787878',
    },
    '& .MuiListItemAvatar-root': {
        margin: 0,
        minWidth: 50,
        '& .MuiAvatar-root': {
            backgroundColor: 'var(--notif-avatar-bg, #002f73)',
            width: 42,
            height: 42,
            '& img': {
                filter: 'brightness(0) invert(1)',
            },
        },
    },


    '&:hover': {
        backgroundColor: '#002f73',
        '& h6': {
            color: '#fff',
        },
        '& p': {
            color: '#fff',
        },
        '& span': {
            color: '#fff',
        },
        '& .MuiListItemAvatar-root': {
            '& .MuiAvatar-root': {
                backgroundColor: '#fff',
                '& img': {
                    filter: 'none',
                },
            },
        },
    },
}));

export const ListItemData = styled(Box)(({ }) => ({
    display: 'flex',
    flexFlow: 'column',
    flex: 1,
    maxWidth: 'calc(100% - 50px)',
}));

export const NoNotification = styled(ListItem)(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    border: 'none',
    padding: theme.spacing(3, 2),
    margin: 0,
    justifyContent:'center',
    alignItems: 'center',
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: 500,
    color: '#383838',
    '& img':{
        display: 'block',
        width: 32,
        margin: theme.spacing(0, 0, 1.25, 0),
    }
}));
